/* Rquiere de mixin.js */

var stringAnalysis = {
	data() {
		return {
			lengthISBN: 13,
			lengthSE: 20,
			lengthMA: 9,
			resultData: null,
		}
	},
	computed: {
	},
	filters: {
	},
	methods: {
		determineDataType(s) {
			this.resultData = this.analizeIsNumber(s)
			this.resultData = (this.resultData == null) ? this.analizeIsSKU(s) : this.resultData
			this.resultData = (this.resultData == null) ? this.analizeIsRUT(s) : this.resultData
			this.resultData = (this.resultData == null) ? this.analizeIsShippingRequest(s) : this.resultData
			this.resultData = (this.resultData == null) ? this.analizeIsManifesto(s) : this.resultData
			this.resultData = (this.resultData == null) ? this.analizeIsStoreRackSideRowColumn(s) : this.resultData
			this.resultData = (this.resultData == null) ? { result: 'CHARACTER', data: s, original: s } : this.resultData
			return this.resultData
		},
		analizeIsNumber(s) {
			if (!isNaN(s)) {
				if (this.isInt(s)) {
					return (s.trim().length == this.lengthISBN) ? { result: 'ISBN', data: s.trim(), original: s } : { result: 'INTEGER', data: s, original: s }
				}
				if (this.isFloat(s)) {
					return { result: 'FLOAT', data: s, original: s }
				}
			}
			return null
		},
		analizeIsSKU(s) {
			if (s.trim().length > 1 && s.trim().substring(0, 1).toUpperCase() == 'H' && this.isInt(s.trim().substring(1, s.trim().length)))
				return { result: 'SKU', data: s.trim().substring(1, s.trim().length), original: s }
			return null
		},
		analizeIsRUT(s) {
			if (this.checkDigitoRUT(s))
				return { result: 'RUT', data: s.replaceAll('.', '').toUpperCase(), original: s }
			return null
		},
		analizeIsEmail(s) {

		},
		analizeIsShippingRequest(s) {
			if (s.trim().length > 2 && s.trim().substring(0, 2).toUpperCase() == 'SE' && this.isInt(s.trim().substring(2, s.trim().length)) && s.trim().length <= this.lengthSE + 2) {
				let data = s.trim().substring(2, s.trim().length)
				data = (data.length > 16) ? data.substring(0, 16) : data
				return { result: 'SHIPPINGREQUEST', data: data, original: s }
			}
			return null
		},
		analizeIsManifesto(s) {
			if (s.trim().length > 2 && s.trim().substring(0, 2).toUpperCase() == 'MA' && this.isInt(s.trim().substring(2, s.trim().length)) && s.trim().length <= this.lengthMA + 2) {
				let data = s.trim().substring(2, s.trim().length)
				return { result: 'MANIFESTO', data: data, original: s }
			}
			return null
		},
		analizeIsStoreRackSideRowColumn(s) {
			let arr = s.split('.')
			if (arr.length == 5) {
				let result = true
				arr.forEach(element => {
					result = (this.isInt(element) && result) ? true : false
				})
				if (result)
					return { result: 'STORERACKSIDEROWCOLUMN', data: arr[4], original: s }
			}
			return null
		}
	},
};

export default stringAnalysis;